import { useState, useMemo } from 'react';
import './App.css';
import songDatabase from './FullList.json';
import AlbumCabinet from './album-cabinet';
import AudioPlayer from './player';
// import P from './myFunctions';

function App() {
  //******************************************************************//
  //                                                                  //
  //                   Variable Declaration Section                   //
  //                                                                  //
  //******************************************************************//
  //  Add a unique key to the song database                           //
  const keyedSongDatabase = useMemo(() => {
    let counter = 0;
    let listBuilder = [];
    songDatabase.forEach((track) => {
      counter++
      track.key = counter;
      listBuilder.push(track);
    })

    return listBuilder;
  }, []); 

  //  This deteremines which type of playlist will be displayed in the cabinet selector at the bottom  //
  //     0 - the set list with top songs and their preferred versions.                                 //
  //     1 - the complete list of songs with all their versions.                                       //
  //     2 - the complete list of sessions with the song versions from those sessions.                 //
  const [listTypeSelector, setListTypeSelector] = useState(0);
  //   This is the variable that holds the key value from the keySongDatabase of the current song in the player.   //
  //   154 refers to Punkhole Surfer.                                                                              //
  const startingSongForSetList = 154;
  const [currentSongSelection, setCurrentSongSelection] = useState(startingSongForSetList);

  const playerPlayList = useMemo(() => {
    let tempPlayList = [];
    switch (listTypeSelector) {
      case 0 :
        let currentTrackCheck = false;
        keyedSongDatabase.forEach((item) => {
          if(item.setList !== "") {
            tempPlayList.push(item);
            if (item.key === currentSongSelection) {
              currentTrackCheck = true;
            }
          }
        });
        if(!currentTrackCheck) {
          setCurrentSongSelection(startingSongForSetList)
        }
        tempPlayList.sort(function(a, b) {
          if (Number(a.setList) < Number(b.setList)) { return -1 };
          if (Number(a.setList) > Number(b.setList)) { return 1 };
          return 0;
        });
        break;
      case 1:
        const currentSong = keyedSongDatabase[keyedSongDatabase.findIndex(track => track.key === currentSongSelection)].song;
        keyedSongDatabase.forEach((item) => {
          if(item.song === currentSong) {
            tempPlayList.push(item);
          }
        });
        break;
      case 2:
        const currentSession = keyedSongDatabase[keyedSongDatabase.findIndex(track => track.key === currentSongSelection)].session;
        keyedSongDatabase.forEach((item) => {
          if(item.session === currentSession) {
            tempPlayList.push(item);
          }
        });
        break;
      default: console.log("There seems to be a problem with the listTypeSelector");
    }

    return tempPlayList;
  }, [keyedSongDatabase, listTypeSelector, currentSongSelection])

  //********************************************************************************//
  //                                                                                //
  //           THESE ARE THE FUNCTION CALLS FOR THE BUTTONS AT THE BOTTOM           //
  //                                                                                //
  //********************************************************************************//
  const selectSetList = () => {
    setListTypeSelector(0);
  };

  const selectBySong = () => {
    setListTypeSelector(1);
  };

  const selectBySession = () => {
    setListTypeSelector(2);
  };

  const playThis = (songNumber) => {
    setCurrentSongSelection(songNumber);
  }

  return (
    <>
      <div className="App">
        <header className="App-header">
          <h2>Dang Blasted Cranks</h2>
          <h3>Mark II Collection</h3>
        </header>
      </div>
      <div className="system">
        <div className="media-player">
          {<AudioPlayer {...{ currentSongSelection, setCurrentSongSelection, playerPlayList }}/>}
        </div>
        <div className="songListDisplay">
          <div className="playlist">
              {(listTypeSelector === 0) && <h2>Most Promising Tunes</h2>}
              {(listTypeSelector === 1) && <h2>{keyedSongDatabase[keyedSongDatabase.findIndex(track => track.key === currentSongSelection)].song}</h2>}
              {(listTypeSelector === 2) && <h2>{keyedSongDatabase[keyedSongDatabase.findIndex(track => track.key === currentSongSelection)].session}</h2>}
              <ul id="song-list">
                  {(listTypeSelector === 0) && playerPlayList.map((track) => <li key={track.song} onClick={() => playThis(track.key)}>{track.setList} - {track.song}</li>)}
                  {(listTypeSelector === 1) && playerPlayList.map((track) => <li key={track.file} onClick={() => playThis(track.key)}>{track.session} - {track.filename}</li>)}
                  {(listTypeSelector === 2) && playerPlayList.map((track) => <li key={track.file} onClick={() => playThis(track.key)}>{track.filename}</li>)}
              </ul>
          </div>
        </div>
        <div className="album-selector">
          <div className="cabinet-controller">
              <button id="button0" onClick={selectSetList}>Setlist</button>
              <button id="button1" onClick={selectBySong}>Song Versions</button>
              <button id="button2" onClick={selectBySession}>Sessions</button>
          </div>
          {<AlbumCabinet {...{ listTypeSelector, keyedSongDatabase, currentSongSelection, setCurrentSongSelection }}/>}
        </div>
      </div>
    </>
  );
}

export default App;
